import { loadStripe } from "@stripe/stripe-js";
import { FunctionComponent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SubscriptionPayment from "src/components/forms/stripe/SubscriptionPayment";
import { PageContainer, PageTitle } from "src/components/generic";
import { capitalizeFirstLetter } from "src/utils/format/strings";
import { CustomerTier, extractCustomerProductInclusions, extractCustomerProductPrice, extractCustomerProductPriceId, isCustomerTier } from "src/utils/pricing";


const Subscribe: FunctionComponent = () => {
    const prod = process.env.REACT_APP_ENV === 'prod';

    const [params] = useSearchParams();
    const navigate = useNavigate();

    const customerId = params.get('scid');
    const tier = params.get('tier');
    console.log({tier})
    const customerTier: CustomerTier | null = tier && isCustomerTier(tier) ? tier : null;
    const currentSelectedTier: CustomerTier = customerTier ?? "gold" as CustomerTier;
    const priceId = extractCustomerProductPriceId(prod, currentSelectedTier);
    const firstPaymentAmount = extractCustomerProductPrice(currentSelectedTier);
    const included = extractCustomerProductInclusions(currentSelectedTier);
    const planName = `${capitalizeFirstLetter(tier || "Premium")} Plan`;

    if(!customerId) return (
        <div></div>
    );

    return (
        <PageContainer>
            <PageTitle title="Subscription" />

            <SubscriptionPayment 
                customerId={customerId}
                priceId={priceId}
                billingCycle="Monthly"
                planName={planName}
                firstPaymentAmount={firstPaymentAmount}
                included={included}
                onSubscriptionComplete={() => navigate('/auth/first-pull')}
            />
        </PageContainer>
    )
}

export default Subscribe;